import { render, staticRenderFns } from "./ImageShowcase.vue?vue&type=template&id=0833512d&scoped=true&"
import script from "./ImageShowcase.vue?vue&type=script&lang=js&"
export * from "./ImageShowcase.vue?vue&type=script&lang=js&"
import style0 from "./ImageShowcase.vue?vue&type=style&index=0&id=0833512d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0833512d",
  null
  
)

export default component.exports